import { motion } from "framer-motion";
import { Handshake, MapPin, PackageCheck, Truck, ArrowUpRight } from "lucide-react";

const PARTNERS = [
  {
    id: "delmax",
    name: "DELMAX",
    desc: "Zvanični partner za rezervne delove, motorna ulja, gume i akumulatore. 57 poslovnica širom Srbije, član međunarodne Temot grupacije — originalni delovi dostupni za naše klijente po partnerskim uslovima.",
    location: "Stara Pazova",
    tag: "Veleprodaja i maloprodaja auto delova",
    tagIcon: PackageCheck,
    url: "https://delmax.rs",
    urlLabel: "delmax.rs",
    logo: <img src="/delmax-logo.png" alt="DELMAX — Sve za auto i kamion" className="h-14 lg:h-16 w-auto" />,
  },
  {
    id: "bexpress",
    name: "BexExpress",
    desc: "Naš partner za dostavu. Sve porudžbine iz prodavnice šaljemo BexExpress kurirskom službom — brza i pouzdana isporuka na kućnu adresu širom Srbije, uz plaćanje pouzećem.",
    location: "Širom Srbije",
    tag: "Kurirska služba i dostava paketa",
    tagIcon: Truck,
    url: "https://www.bex.rs",
    urlLabel: "bex.rs",
    logo: <img src="/bex-logo.png" alt="BexExpress kurirska služba" className="h-14 lg:h-16 w-auto" />,
  },
];

export default function Partners() {
  return (
    <section id="partneri" data-testid="partners-section" className="relative py-16 lg:py-20 px-6 lg:px-12 border-y border-white/[0.06] bg-[#0a0a0d] overflow-hidden">
      <div className="absolute -bottom-24 left-1/3 w-96 h-96 rounded-full bg-red-600/[0.05] blur-3xl pointer-events-none" />

      <div className="relative max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="flex items-center gap-3 mb-10"
        >
          <Handshake size={16} className="text-red-500" />
          <span className="text-red-500 text-xs font-bold tracking-[0.3em] uppercase">Naši partneri</span>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-5">
          {PARTNERS.map((p, i) => (
            <motion.a
              key={p.id}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`partner-card-${p.id}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: "easeOut" }}
              whileHover={{ y: -5 }}
              className="group flex flex-col gap-7 bg-[#121216] border border-white/[0.07] hover:border-red-600/40 rounded-3xl p-8 transition-colors hover:shadow-[0_12px_48px_rgba(227,22,30,0.14)]"
            >
              <div className="flex items-center justify-between gap-4">
                {p.logo}
                <span className="hidden sm:flex items-center gap-1.5 text-sm font-semibold text-zinc-500 group-hover:text-red-400 transition-colors">
                  {p.urlLabel}
                  <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </div>
              <div>
                <p className="text-sm text-zinc-400 leading-relaxed">{p.desc}</p>
                <div className="flex flex-wrap items-center gap-x-5 gap-y-2 mt-4 text-xs text-zinc-500">
                  <span className="flex items-center gap-1.5">
                    <MapPin size={12} className="text-red-500" /> {p.location}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <p.tagIcon size={12} className="text-red-500" /> {p.tag}
                  </span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
